import { render, staticRenderFns } from "./DomesticPaymentsReview.vue?vue&type=template&id=3051afc6"
import script from "./DomesticPaymentsReview.vue?vue&type=script&lang=js"
export * from "./DomesticPaymentsReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports